'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _ChatHeadingConfigTypes = require('../constants/ChatHeadingConfigTypes');

var _buildChatHeadingConfig = require('../builders/buildChatHeadingConfig');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OwnerChatHeadingConfig = function (_Record) {
  _inherits(OwnerChatHeadingConfig, _Record);

  function OwnerChatHeadingConfig(options) {
    _classCallCheck(this, OwnerChatHeadingConfig);

    var optionMap = (0, _immutable.fromJS)(options);
    var fallback = (0, _get2.default)('fallback', optionMap);
    return _possibleConstructorReturn(this, (OwnerChatHeadingConfig.__proto__ || Object.getPrototypeOf(OwnerChatHeadingConfig)).call(this, {
      fallback: (0, _buildChatHeadingConfig.buildChatHeadingConfig)(fallback)
    }));
  }

  return OwnerChatHeadingConfig;
}((0, _immutable.Record)({
  '@type': _ChatHeadingConfigTypes.OWNER,
  fallback: null
}, 'OwnerChatHeadingConfig'));

exports.default = OwnerChatHeadingConfig;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/chat-heading-config/records/OwnerChatHeadingConfig.js
// module id = 925
// module chunks = 2 3